"use client";

import { useMotionMode } from "@/context/MotionContext";
import { getScrimColor } from "@/utils/colors";

// =============================================================================
// TOP SCRIM
// =============================================================================
// Radial gradient scrim that fades content scrolling behind the hero lockup.
// Used by content overlays (Manifesto, Resume, Blog) for consistent contrast.

interface TopScrimProps {
  isActive: boolean;
  isScrolled: boolean;
  z1Height: number;
  isLightMode?: boolean;
}

export function TopScrim({ isActive, isScrolled, z1Height, isLightMode = false }: TopScrimProps) {
  const scrimColor = getScrimColor(isLightMode);
  const { canAnimate } = useMotionMode();

  // Height covers hero zone + generous buffer for subtitles
  const scrimHeight = z1Height + 140;

  return (
    <div
      className="fixed left-0 right-0 z-[13] pointer-events-none"
      style={{
        top: 0,
        height: scrimHeight,
        background: `radial-gradient(ellipse 90% 100% at 50% 0%, rgba(${scrimColor},0.95) 0%, rgba(${scrimColor},0.7) 40%, rgba(${scrimColor},0.3) 70%, transparent 100%)`,
        opacity: isActive && isScrolled ? 1 : 0,
        transition: canAnimate ? `opacity ${isActive ? 400 : 150}ms ease-out` : "none",
      }}
    />
  );
}
